import React from 'react';
import PropTypes from 'prop-types';
import CommonAppSetup from '../../../common/common-app-setup/CommonAppSetup';
import icon from '../../../common/icons/Icons';
import Components from '../../../common/Components';
import joinClassNames from "../../../common/JoinClassNames";

// A custom button to be used with the DatePicker (react-datepicker)
// Usually a DatePicker is attached to a text input.
// To attach it to a button you must provide the DatePicker a custom input component to use.
// https://reactdatepicker.com/#example-40

const propTypes = {
	// A function that returns an icon, usually an svg icon to show.
	icon: PropTypes.func,

	// Callback function when the button is clicked.
	// This function is used automagically by the DatePicker
	onClick: PropTypes.func,

	// If you don't provide an icon you can prevent display of the default icon.
	showDefaultIcon: PropTypes.bool,

	// Controls the css class that will hide and show the button text
	showText: PropTypes.bool,

	// value is set automagically by the DatePicker component
	// we are not using "value" to display anything on the button
	// included so that future implementation can be done if desired
	value: PropTypes.string,
};

// Default props are provided by the parent component DatePickerButton
const defaultProps = {
	icon: undefined,
	onClick: undefined,
	showDefaultIcon: true,
	showText: false,
	value: undefined,
};

const datePickerIconCssClass = 'date-picker-button__icon';

export default class CustomButtonForDatePicker extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<button
				type="button"
				className={joinClassNames(
					'date-picker-button',
					CommonAppSetup.getClassName(Components.CALENDAR_INPUT, 'button')
				)}
				onClick={this.props.onClick}
			>
				{this.props.icon ? this.props.icon(datePickerIconCssClass) : this.props.showDefaultIcon && icon.iconCalendar(datePickerIconCssClass)}
				<span className={joinClassNames(
					'date-picker-button__text',
					!this.props.showText ? 'visually-hidden' : ''
				)}>Choose</span>
			</button>
		);
	}
}

CustomButtonForDatePicker.propTypes = propTypes;
CustomButtonForDatePicker.defaultProps = defaultProps;